import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        showFilter: '=',
        classifiers: '=',
        defaultFilter: '=',
        list: '=',
        skillProficiencies: '='
    },
    template: `
        <div class="form form-filter type03">
            <form ng-submit="vm.applyFilter()" class="form form-filter" ng-if="vm.showFilter">
                <div class="fields">
                    <div class="row row-md">
                        <label class="label">{{ 'skill.name' | translate }}</label>
                        <div class="items">
                            <input type="text" class="form-control"  ng-model="vm.filter.name">
                        </div>
                    </div>
                    <div class="row separated">
                        <label class="label">{{ 'skill.directManager' | translate }}</label>
                        <div class="items">
                            <autocomplete
                                label-attribute="'displayName'"
                                selected-item="vm.directManagerId"
                                ng-model="vm.filter.directManagerId"
                                value-attribute="'id'"
                                query="vm.queryUsers(input)"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'skill.proficiency' | translate }}</label>
                        <div class="items" style="position: relative; z-index: 10;">
                              <div
                                ng-dropdown-multiselect=""
                                options="vm.proficiencies"
                                selected-model="vm.filter.proficiencyIds"
                                extra-settings="{
                                    checkBoxes: true,
                                    showCheckAll: true,
                                    showUncheckAll: true,
                                    smartButtonMaxItems: 3,
                                    displayProp: 'label',
                                    idProp: 'id'
                                }"
                                translation-texts="vm.filterTranslations">
                             </div>
                        </div>
                    </div>
                    <div class="row row-md">
                        <span class="label">{{ 'skill.onlyEmployeesWithSkillGap' | translate }}</span>
                            <div class="items">
                                <ul class="checkboxes03 nowrap">
                                    <li>
                                        <label>
                                            <input type="radio" name="r02" ng-model="vm.filter.onlyEmployeeWithSkillGap" value="yes">
                                            <span>{{ 'skill.yes' | translate }}</span>
                                        </label>
                                    </li>
                                    <li>
                                        <label>
                                            <input type="radio" name="r02" ng-model="vm.filter.onlyEmployeeWithSkillGap" value="no" checked="checked">
                                            <span>{{ 'skill.no' | translate }}</span>
                                        </label>
                                    </li>
                                </ul>
                            </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'skill.site' | translate }}</label>
                        <div class="items">
                            <div
                                ng-dropdown-multiselect=""
                                options="vm.multiFilter.sites.options"
                                selected-model="vm.multiFilter.sites.model"
                                extra-settings="vm.multiFilter.sites.settings"
                                ng-click="vm.updateEmployees()"
                                translation-texts="vm.filterTranslations"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'skill.department' | translate }}</label>
                        <div class="items">
                            <div class="items">
                                <div ng-dropdown-multiselect=""
                                    options="vm.FilterService.departmentSelect.options"
                                    selected-model="vm.FilterService.departmentSelect.models"
                                    extra-settings="vm.FilterService.departmentSelect.settings"
                                    events="vm.FilterService.departmentSelect.events"
                                    translation-texts="vm.filterTranslations"
                                ></div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'skill.role' | translate }}</label>
                        <div class="items">
                            <div class="items">
                                <div ng-dropdown-multiselect=""
                                    options="vm.FilterService.roleSelect.options"
                                    selected-model="vm.FilterService.roleSelect.models"
                                    extra-settings="vm.FilterService.roleSelect.settings"
                                    events="vm.FilterService.roleSelect.events"
                                    translation-texts="vm.filterTranslations"
                                ></div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'skill.level' | translate }}</label>
                        <div class="items">
                            <div class="items">
                                <div ng-dropdown-multiselect=""
                                    options="vm.FilterService.levelSelect.options"
                                    selected-model="vm.FilterService.levelSelect.models"
                                    extra-settings="vm.FilterService.levelSelect.settings"
                                    events="vm.FilterService.levelSelect.events"
                                    translation-texts="vm.filterTranslations"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
                <ul class="actions01">
                    <li><input type="button" class="btn discrete" value="{{ 'filter.Reset' | translate }}" ng-click="vm.resetFilters()"></li>
                    <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
                </ul>
            </form>
        </div>
       `
})

export default class {
    constructor ($translate, lodash, CLASSIFIER_ENUM, UserService, SiteService, ROLE_PRIVILEGE_ENUM, ListFactory,
                 ROLE_CODE_ENUM, UserResource, FilterService, PrivilegeService, TokenService, UserSkillResource) {
        this.TokenService = TokenService;
        this.$translate = $translate;
        this.lodash = lodash;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.UserService = UserService;
        this.FilterService = FilterService;
        this.SiteService = SiteService;
        this.PrivilegeService = PrivilegeService;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.ROLE_PRIVILEGE_ENUM = ROLE_PRIVILEGE_ENUM;
        this.UserResource = UserResource;
        this.UserSkillResource = UserSkillResource;
        this.ListFactory = ListFactory;
    }

    $onInit () {
        this.initFilters();

        this.filterTranslations = this.FilterService.getTranslations();
        const classifiers = Array.isArray(this.classifiers) ? this.classifiers : [];
        this.departments = classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        this.roles = classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.ROLE);
        this.levels = classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.LEVEL);
        this.sites = this.SiteService.getSitesByPrivileges(
            [this.ROLE_PRIVILEGE_ENUM.KEYS.EMPLOYEE_VIEW, this.ROLE_PRIVILEGE_ENUM.KEYS.EMPLOYEE_MANAGE]
        );

        this.getProficiencies();
        this.initMultiFilter(classifiers);
    }

    initFilters () {
        this.filter = this.filter || {};
        this.filter.onlyEmployeeWithSkillGap = 'no';
        this.filter.directManagerId = null;
        this.filter.proficiencyIds = [];
    }

    initMultiFilter (classifiersOverride) {
        let classifiers = [];
        if (Array.isArray(classifiersOverride)) {
            classifiers = classifiersOverride;
        }
        else if (Array.isArray(this.classifiers)) {
            classifiers = this.classifiers;
        }
        this.FilterService.init(classifiers);

        const siteOptions = this.sites.map(site => {
            return {
                value: site.id,
                label: site.name
            };
        });

        const siteOptionsSelected = siteOptions.map(site => site);
        const proficiencyOptions = this.skillProficiencies.map(proficiency => {
            return {
                value: proficiency.points,
                label: proficiency.activeI18n ? proficiency.activeI18n.value : proficiency.points
            };
        });
        const proficienciesSelected = proficiencyOptions.map(proficiency => proficiency.points);
        this.multiFilter = {
            sites: {
                model: siteOptionsSelected,
                options: siteOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            },
            proficiencies: {
                model: proficiencyOptions,
                options: proficienciesSelected,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            }
        };
        // this is used when filter is reset
        this.defaultMultiFilter = angular.copy(this.multiFilter);
    }

    _getProficiencyLabel (p) {
        const lang = this.TokenService.getActiveLanguage();
        if (p) {
            if (p.activeI18n && p.activeI18n.value) return p.activeI18n.value;
            if (p.skillProficiencyI18n && p.skillProficiencyI18n[lang] && p.skillProficiencyI18n[lang].value) {
                return p.skillProficiencyI18n[lang].value;
            }
            if (Array.isArray(p.translations)) {
                const found = p.translations.find(t => t && t.language === lang && t.value);
                if (found && found.value) return found.value;
                const first = p.translations.find(t => t && t.value);
                if (first && first.value) return first.value;
            }
            if (typeof p.label !== 'undefined') return p.label;
            if (typeof p.value !== 'undefined') return String(p.value);
            if (typeof p.points !== 'undefined') return String(p.points);
            if (typeof p.id !== 'undefined') return String(p.id);
        }
        return '';
    }

    queryUsers (input) {
        const params = {
            roleCode: this.ROLE_CODE_ENUM.KEYS.DIRECT_MANAGER,
            'siteIds[]': this.sites.map(site => site.id),
            name: input,
            pageSize: 0
        };
        return this.UserResource.query(params).$promise;
    }

    applyFilter () {
        const siteIds = this.multiFilter.sites.model.map(site => site.value);

        const departmentIds = this.FilterService.departmentSelect.models
            .filter((department) => department.id !== null)
            .map((department) => department.id);

        const roleIds = this.FilterService.roleSelect.models
            .filter((role) => role.id !== null)
            .map(role => role.id);

        const levelIds = this.FilterService.levelSelect.models
            .filter((level) => level.id !== null)
            .map(level => level.id);

        const selectedProfIds = Array.isArray(this.filter.proficiencyIds)
            ? this.filter.proficiencyIds.map(p => (p && typeof p.id !== 'undefined') ? p.id : p).filter(Boolean)
            : [];
        const skillGap = (this.filter.onlyEmployeeWithSkillGap === 'yes');

        const params = {
            skillId: this.defaultFilter.skillId,
            includeInactiveSkills: true,
            siteIds,
            userName: this.filter.name || undefined,
            userDirectManagerId: this.filter.directManagerId || undefined,
            skillProficiencies: selectedProfIds,
            onlyUsersWithSkillGap: skillGap,
            userDepartmentIds: departmentIds,
            userRoleIds: roleIds,
            userLevelIds: levelIds,
            expand: 'user.directManagers,skill,skill.explanations,skill.explanations.i18ns,skill.explanations.activeI18n,' +
                'skill.scale.scaleI18ns,skill.scale.proficiencies,skill.activeI18n,' +
                'user.userAssignments,user.drlsWithValue,skill.explanations.proficiency,proficiency.activeI18n,' +
                'requiredProficiency,proficiency,skill.i18ns'
        };

        this.list = this.ListFactory.createWithPagination(this.UserSkillResource.search.bind(this.UserSkillResource));
        this.list.pagination.perPage = 50;

        this.list.fetch({ expand: 'user.directManagers,skill,skill.explanations,skill.explanations.i18ns,skill.explanations.activeI18n,' +
                'skill.scale.scaleI18ns,skill.scale.proficiencies,skill.activeI18n,' +
                'user.userAssignments,user.drlsWithValue,skill.explanations.proficiency,proficiency.activeI18n,' +
                'requiredProficiency,proficiency,skill.i18ns' }, params);
    }

    resetFilters () {
        // Reset basic filter fields to their default state
        this.initFilters();
        this.filter.name = '';
        this.multiFilter = angular.copy(this.defaultMultiFilter);
        this.FilterService.initClassifierMultiFilter();
        if (this.FilterService.departmentSelect) this.FilterService.departmentSelect.models = [];
        if (this.FilterService.roleSelect) this.FilterService.roleSelect.models = [];
        if (this.FilterService.levelSelect) this.FilterService.levelSelect.models = [];

        // Apply cleared filters
        this.applyFilter();
    }

    getProficiencies () {
        // Normalize and deduplicate proficiencies in a single pass
        const rawProficiencies = Array.isArray(this.skillProficiencies) ? this.skillProficiencies : [];

        const uniqueProficienciesMap = rawProficiencies.reduce((map, p) => {
            const id = (typeof p.id !== 'undefined') ? p.id : (p.value || p.points);
            if (id !== undefined && id !== null && !map.has(id)) {
                map.set(id, {
                    id,
                    label: this._getProficiencyLabel(p)
                });
            }
            return map;
        }, new Map());

        this.proficiencies = Array.from(uniqueProficienciesMap.values());
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/user/skills/users/filter/index.js